import { useTranslation } from "react-i18next";

const schools = [
  "Delhi Public School Bangalore South", "The NGP School, Coimbatore", "Sir Sivaswami School, Chennai","Oberoi International School, Mumbai","Head Start Educational Academy, Bangalore",
  "Vikas Bharati Public School, Delhi", "Mayoor School, Noida", "Colonel's Central Academy School, Gurugram, Haryana"," CHIREC International School, Hyderabad",
  "DL DAV Model School Pitampura","Anand Niketan Satellite International School", "The International School of Bangalore","Head Start Educational Academy,Bangalore"
];

export default function TrustedBy() {
  const { t } = useTranslation("landing");
  const loop = [...schools, ...schools];

  return (
    <section className="bg-white py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 text-center lg:px-8">
        <p className="label-eyebrow">{t("schools.eyebrow", { defaultValue: "Trusted Worldwide" })}</p>
        <h2 className="mt-3 text-3xl font-bold text-navy sm:text-4xl">
          {t("schools.title")}
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-base text-slate-body">
          {t("schools.subtitle")}
        </p>
      </div>

      <div className="relative mt-12 overflow-hidden [mask-image:linear-gradient(90deg,transparent,#000_10%,#000_90%,transparent)]">
        <div className="marquee flex w-max gap-3">
          {loop.map((s, i) => (
            <span
              key={i}
              className="whitespace-nowrap rounded-full border border-border bg-surface px-5 py-2.5 text-sm font-semibold text-slate-body"
            >
              {s}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
